import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title" }, "Payment method", -1)
const _hoisted_2 = { class: "d-flex flex-column gap-2 item-content mt-3" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "dd-payment-method-radio" }, "I want to pay using the direct debit details above", -1)
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "ob-payment-method-radio" }, "I want to switch to online banking", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-2 item-validation-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          id: "dd-payment-method-radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDirectDebitAccepted) = $event)),
          type: "radio",
          class: _normalizeClass(["form-check-input radio-check-booster-blue", {'validation-error' : _ctx.validationError}]),
          value: true
        }, null, 2), [
          [_vModelRadio, _ctx.isDirectDebitAccepted]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          id: "ob-payment-method-radio",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDirectDebitAccepted) = $event)),
          type: "radio",
          class: _normalizeClass(["form-check-input radio-check-booster-blue", {'validation-error' : _ctx.validationError}]),
          value: false
        }, null, 2), [
          [_vModelRadio, _ctx.isDirectDebitAccepted]
        ]),
        _hoisted_6
      ]),
      (_ctx.validationError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.validationError), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}